import { useEffect } from 'react';
import { useReports } from '../../hooks/useReports';
import { useAuth } from '../../hooks/useAuth';
import { track } from '../../services/events';
import { useToast } from '../feedback/AppToast';
import { ReportList } from './ReportList';
import { ReportDetail } from './ReportDetail';

export function ReportPage({
  reportId,
  onSelect,
  onBackToEvaluate
}: {
  reportId?: string;
  onSelect: (id: string) => void;
  onBackToEvaluate: () => void;
}) {
  const auth = useAuth();
  const toast = useToast();
  const reports = useReports(reportId);
  useEffect(() => {
    track('report_history_click');
    if (!auth.loading && !auth.user) auth.openAuth();
  }, []);
  useEffect(() => {
    if (!reportId && reports.list?.list[0]) onSelect(reports.list.list[0].id);
  }, [reportId, reports.list]);
  const retry = async (articleId: string) => {
    try {
      await reports.retry(articleId);
      toast('该文章已重新提交', 'success');
    } catch (e) {
      toast(e instanceof Error ? e.message : '重试失败', 'error');
    }
  };
  if (!auth.loading && !auth.user)
    return (
      <main className="container section">
        <div className="state-box large">
          <h2>登录后查看我的报告</h2>
          <p>报告仅对当前独立文章评测账号可见。</p>
          <button className="btn" onClick={auth.openAuth}>
            手机号登录
          </button>
        </div>
      </main>
    );
  return (
    <main className="container reports show">
      <div className="section-title">
        <div>
          <h2>我的报告</h2>
          <p>查看历史评测、部分失败结果，并只重试失败文章。</p>
        </div>
        <button className="btn secondary" onClick={onBackToEvaluate}>
          创建新评测
        </button>
      </div>
      <div className={`report-layout ${reportId ? 'mobile-detail-open' : ''}`}>
        <ReportList
          data={reports.list}
          loading={reports.listLoading}
          error={reports.listError}
          selectedId={reportId}
          status={reports.status}
          onStatus={(value) => {
            reports.setStatus(value);
            reports.setPage(1);
          }}
          onSelect={onSelect}
          onPage={reports.setPage}
          onRetry={() => void reports.reloadList()}
        />
        <section className="detail-shell">
          {reportId && (
            <button className="mobile-back" onClick={() => history.back()}>
              ← 返回报告列表
            </button>
          )}
          {reports.detailLoading ? (
            <div className="state-box large">
              <span className="spinner dark" />
              正在加载报告详情…
            </div>
          ) : reports.detailError ? (
            <div className="state-box large error">
              <p>{reports.detailError}</p>
              <button className="btn secondary" onClick={() => void reports.reloadDetail()}>
                重新加载
              </button>
            </div>
          ) : reports.detail ? (
            <ReportDetail
              report={reports.detail}
              retryingArticleId={reports.retryingArticleId}
              onRetry={retry}
            />
          ) : (
            <div className="state-box large">
              <strong>请选择一份报告</strong>
              <p>从左侧列表查看评测结果。</p>
            </div>
          )}
        </section>
      </div>
    </main>
  );
}
